import type {
  CoreCoachEditionsCreateParams,
  CoreCoachEditionsDeleteParams,
  CoreCoachEditionsReadParams,
  CoreCoachEditionsSignParams,
  CoreCoachEditionsUpdateParams,
} from '../../types/core/methods';
import type {EditionApiModel} from './types';

import {EntityStore} from '../../utils/entityStore';

export class EditionStore<
  T extends EditionApiModel = EditionApiModel,
> extends EntityStore<
  T,
  CoreCoachEditionsReadParams,
  CoreCoachEditionsCreateParams,
  CoreCoachEditionsUpdateParams,
  CoreCoachEditionsDeleteParams
> {
  sign = this._createMethod<CoreCoachEditionsSignParams>({
    method: 'coach.editions.sign',
  });
}

export const editionStore = new EditionStore('edition', {
  create: 'coach.editions.create',
  delete: 'coach.editions.delete',
  fetch: 'coach.editions.read',
  update: 'coach.editions.update',
});
